import { z } from "zod";

// Rails serializes decimals as strings; Nuabase responses may send numbers. Coerce both into numbers.
export const zRailsNumericString = z.union([z.string(), z.number()]).transform((value) => Number(value)).pipe(z.number());
